var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M4 4H20V20H4V4Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }